import * as A from 'fp-ts-esm/Array';
import { identity, pipe } from 'fp-ts-esm/function';
import type * as J from 'fp-ts-esm/Json';
import { concatAll } from 'fp-ts-esm/Monoid';
import * as R from 'fp-ts-esm/Record';
import { first } from 'fp-ts-esm/Semigroup';
import * as T from 'fp-ts-esm/Tuple';

import type { ListValue, Struct, Value } from './../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';

import { firstRight } from '../../../fp-utils.js';
import * as SRT from '../struct-refined-types.js';

const mergeJsonMap = R.getMonoid(first<J.Json>());
const toRecord = ([k, v]: [string, J.Json]): J.JsonRecord => ({ [k]: v });

export const convertStructToJson = (message: Struct): J.JsonRecord =>
  pipe(
    message.fields,
    Object.entries,
    A.map(T.bimap(convertValueToJson, identity)),
    A.map(toRecord),
    concatAll(mergeJsonMap)
  );

const convertValueToJson = (message: Value): J.Json =>
  firstRight(message, null as J.Json, [
    [SRT.isBoolValue, ({ boolValue }) => boolValue as boolean],
    [SRT.isNumberValue, ({ numberValue }) => numberValue as number],
    [SRT.isStringValue, ({ stringValue }) => stringValue as string],
    [SRT.isNullValue, () => null],
    [SRT.isArrayValue, m => convertListToJson(m.listValue || { values: [] })],
    [SRT.isStructValue, m => convertStructToJson(m.structValue || { fields: {} })],
  ]);

const convertListToJson = (message: ListValue): J.JsonArray =>
  pipe(message.values, A.map(convertValueToJson));
